import React from 'react'
import PropTypes from 'prop-types'

import './CannedDeliveryInstructions.css'

export const CannedDeliveryInstructions = ({ content }) => {
  return (
    <React.Fragment>
      <div data-testid='canned-delivery-instructions'>
        <div styleName='header'>Request contactless delivery</div>
        <div data-testid='canned-delivery-text'>
          {content}
        </div>
      </div>
    </React.Fragment>
  )
}

CannedDeliveryInstructions.propTypes = {
  content: PropTypes.node.isRequired
}
